// frontend/src/services/siteService.js
/*Provides API helper functions for fetching site data from the backend.
Encapsulates HTTP requests for both company-wide sites and agency-restricted (contract-aware) sites, normalizing responses so callers always receive a simple array of site objects.*/ 
import axios from 'axios';

/**
 * Fetch sites for the logged-in user's company.
 * Backend scopes by req.user.companyId.
 */
export async function fetchMyCompanySites() {
  const { data } = await axios.get('/sites');

  // support both: { sites: [...] } and [...]
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.sites)) return data.sites;

  return [];
}

/**
 * Fetch sites the current agency is allowed to operate on
 * (contract + contract_sites enabled, contract active).
 */
export async function fetchMyAgencyAllowedSites() {
  const { data } = await axios.get('/agencies/me/sites');

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.sites)) return data.sites;

  return [];
}
